import naiveDialogInfo from './naiveDialogInfo'
import Vue from 'vue'


/**
 * 创建dialog 返回 instan 实例
 * @param vm 调用该组件vue实例
 * @param dialog dialog弹出层配置
 * @param dialogListeners dialog 事件注册
 * @param assembly 具体组件配置
 * @param assemblyListeners 具体组件事件注册
 * @param namespace 具体组件路由
 * @param $scopedSlots 插槽
 * @param callBack 回调函数。返回dialog实例,代码控制dialog生命周期。
 */
let createDialog = function (vm, {
    dialogConfig,
    dialogListeners,
    assemblyConfig,
    whetherDestruction,
    assemblyListeners,
    namespace,
    $scopedSlots
}, callBack) {
    if (!vm.$createDialogCdRwInformation)
        Vue.createAPI(naiveDialogInfo, false);
    let instan = vm.$createDialogCdRwInformation({
        $props: {
            
            dialogConfig,
            assemblyConfig,
            assemblyListeners,
            namespace,
            dialogListeners,
            whetherDestruction
        },
        $scopedSlots
    }, false);
    instan.$parent.destroy = function () {
        this.$destroy();
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
    }
    instan.openDialog();
    if (callBack) callBack(instan)
}

export default createDialog